// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"233c92b8","455":"30b1cc16","977":"46152da0"}[chunkId] + ".chunk.js";
};